import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { IItems } from '../form.interface';
import { getConnectorDisabledItems } from './connector';
import { getGroupDisabledItems } from './group';
import { getImageDisabledItems } from './image';
import { getMultiDisabledItems } from './multiply';
import { getShapeDisabledItems } from './shape';
import { getTableDisabledItems } from './table';

/**
 * 侧边栏需要置灰的设置项。
 * 根据所选元素type进行分类。如表格-旋转需要置灰。
 * @param model 所选元素
 * @returns
 */
export const getFormDisabledItems = (model: IElementBaseModel | IMultiplyModel): IItems => {
    // 形状
    if (model.type === UIModelType.SHAPE) {
        return getShapeDisabledItems(model as IShapeModel);
    }
    // 表格
    if (model.type === UIModelType.TABLE) {
        return getTableDisabledItems(model as ITableModel);
    }
    // 图片
    if (model.type === UIModelType.IMAGE) {
        return getImageDisabledItems(model as IPictureModel);
    }
    // 连接线
    if (model.type === UIModelType.CONNECTOR) {
        return getConnectorDisabledItems(model as IConnectorModel);
    }
    // 多选
    if (model.type === UIModelType.MULTIPLY) {
        return getMultiDisabledItems(model as IMultiplyModel);
    }
    // 组合
    if (model.type === UIModelType.GROUP) {
        return getGroupDisabledItems(model as IGroupModel);
    }
    return {};
};
